import { render, staticRenderFns } from "./commonTableModal.vue?vue&type=template&id=b747c470&"
import script from "./commonTableModal.vue?vue&type=script&lang=js&"
export * from "./commonTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports